module.exports = __webpack_public_path__ + "static/media/RVTN09.9c2b699a.jpg";